<template lang="pug">
    v-btn.btnUpload(
        color="action"
        :loading="isLoading"
        :disabled="isLoading"
        large
    )
        slot
        input(v-if="ext" type="file" ref="fileInput" @change="fileSelected" :accept="ext")
        input(v-if="!ext" type="file" ref="fileInput"  @change="fileSelected")
</template>

<script>
    import VueTypes from 'vue-types';

    export default {
        props: {
            selectedCallback: VueTypes.func.def(() => {}),
            isLoading: VueTypes.bool.def(false),
            ext: VueTypes.string.def('')
        },
        methods: {
            fileSelected(e) {
                if (this.selectedCallback) {
                    if (e.target.files[0]) {
                        this.selectedCallback(e.target.files[0]);
                        this.$refs.fileInput.value = '';
                    } else {
                        this.selectedCallback(null);
                    }
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    .btnUpload
        cursor: pointer
        position: relative
        overflow: hidden
        min-width: 160px
        border-relative: 10px
        margin: 10
        padding: 0 35px
        font-weight: 400
        box-shadow: none !important
        border-radius: 10px

    .btnUpload input[type=file]
        position: absolute
        height: 44px;
        top: -13px;
        width: calc(100% + 70px);
        left: -35px;
        text-align: right
        opacity: 0
        outline: none
        cursor: inherit
        display: block
</style>
